import { render } from "./ArtEditor.vue?vue&type=template&id=d0541874&scoped=true"
import script from "./ArtEditor.vue?vue&type=script&lang=js"
export * from "./ArtEditor.vue?vue&type=script&lang=js"

import "./ArtEditor.vue?vue&type=style&index=0&id=d0541874&scoped=true&lang=css"
import "./ArtEditor.vue?vue&type=style&index=1&id=d0541874&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0541874"]])

export default __exports__